import MainPageCommonService from "../../services/main-page/MainPageCommonService";
import ClickEvent = JQuery.ClickEvent;
import MainPageCardsService from "../../services/main-page/MainPageCardsService";
import MainPageFirstScreenMobile from "./screens/first/MainPageFirstScreenMobile";
import MainPageFirstScreenCommon from "./screens/first/MainPageFirstScreenCommon";
import MainPageSecondScreenMobile from "./screens/second/MainPageSecondScreenMobile";
import AsyncHelper from "../../helpers/AsyncHelper";
import MainPageThirdScreenMobile from "./screens/third/MainPageThirdScreenMobile";
import MainPageFourthScreenMobile from "./screens/fourth/MainPageFourthScreenMobile";
import MainPageCardsScreensMobileService from "../../services/main-page/MainPageCardsScreensMobileService";
import MainPageFifthScreenMobile from "./screens/fifth/MainPageFifthScreenMobile";

export default class MainPageMobile extends MainPageCommonService {
    private readonly $holder: JQuery;

    private CardsService: MainPageCardsService;
    private FirstScreen: MainPageFirstScreenMobile;
    private SecondScreen: MainPageCardsScreensMobileService;
    private ThirdScreen: MainPageThirdScreenMobile;
    private FourthScreen: MainPageFourthScreenMobile;
    private FifthScreen: MainPageCardsScreensMobileService;

    constructor($holder: JQuery) {
        super();

        this.$holder = $holder;

        this.CardsService = new MainPageCardsService(this.$holder);
        this.FirstScreen = new MainPageFirstScreenMobile(this.$holder);
        this.SecondScreen = new MainPageCardsScreensMobileService(new MainPageSecondScreenMobile(this.$holder));
        this.ThirdScreen = new MainPageThirdScreenMobile(this.$holder);
        this.FourthScreen = new MainPageFourthScreenMobile(this.$holder);
        this.FifthScreen = new MainPageCardsScreensMobileService(new MainPageFifthScreenMobile(this.$holder));

        this.scrollHandler = this.scrollHandler.bind(this);
        this.resizeScreen = this.resizeScreen.bind(this);

        this.initScrollTriggerEvents = this.initScrollTriggerEvents.bind(this);
        this.initEvents = this.initEvents.bind(this);

        void this.init();
    }

    /**
     * Инициализация страницы
     * @private
     */
    private async init() {
        this.$body.addClass(this.HIDDEN_CLASS);
        this.scrollToTop(0.2, () => {

        });
        await AsyncHelper.delay(0.2, true);

        this.CardsService.initMobileCardsSliders();

        await this.initScrollTriggerEvents();
        this.initEvents();

        // делаем в начале инициализации страницы задержку на секунду, чтобы прогрузились все анимашки
        await AsyncHelper.delay(0.6, true);
        this.$body.removeClass(this.HIDDEN_CLASS);
    }

    /**
     * Инициализация событий на странице
     * @private
     */
    private initEvents(): void {
        this.resizeScreen();
        window.addEventListener('resize', this.resizeScreen);

        this.scrollHandler();
        $(window).on('scroll', this.scrollHandler);

        const {$labels, changeLabelsOnFirstScreen} = this.FirstScreen;

        changeLabelsOnFirstScreen($labels.first());
        $labels.off().on('click', (event: ClickEvent) => {
            const target = event.target.closest(MainPageFirstScreenCommon.selectors.label);
            if (!target) return;

            changeLabelsOnFirstScreen($(target));
        });

        this.ThirdScreen.initMobileEvents();
    }

    /**
     * Инициализация событий на странице, связанных со scrollTrigger
     * @private
     */
    private async initScrollTriggerEvents(): Promise<void> {
        this.SecondScreen.initScreenScrollingAnimations();
        await this.ThirdScreen.initScreenScrollingAnimations();
        this.FourthScreen.initScreenScrollingAnimations();
        this.FifthScreen.initScreenScrollingAnimations();
    }

    /**
     * Функция обработчик скрола
     * @private
     */
    private scrollHandler(): void {
        const headerContainerHeight = this.headerHeight;
        const scrollPosition = window.pageYOffset;

        scrollPosition >= headerContainerHeight ?
            this.$holder.addClass(this.HEADER_WHITE_HEADER_CLASS) :
            this.$holder.removeClass(this.HEADER_WHITE_HEADER_CLASS);
    }

    /**
     * Callback для resize у страницы
     * @private
     */
    private resizeScreen(): void {
        this.setHeightCharacteristics();
    }
}
